import { useEffect, useState } from "react";
import {
  fetchInternalDocumentPreviewBlobUrl,
  PREVIEWABLE_MIME_TYPES,
} from "../../helpers/internal_documentation_helper";

/**
 * Carga la blob URL del preview cuando `openDoc` cambia. Libera la URL
 * al cerrar o cambiar de documento. Solo dispara la petición si el MIME
 * está en la whitelist; para el resto deja `previewUrl=null` sin error.
 *
 * Devuelve: { previewUrl, previewLoading, previewError }
 */
export function useInternalDocumentPreview(openDoc) {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewError, setPreviewError] = useState(null);

  useEffect(() => {
    if (!openDoc) {
      setPreviewError(null);
      return undefined;
    }
    const canPreview = PREVIEWABLE_MIME_TYPES.has(openDoc.mime_type);
    if (!canPreview) {
      setPreviewUrl(null);
      setPreviewError(null);
      return undefined;
    }

    let revoked = false;
    let urlToRevoke = null;
    setPreviewLoading(true);
    setPreviewError(null);
    fetchInternalDocumentPreviewBlobUrl(openDoc.id)
      .then((url) => {
        if (revoked) {
          window.URL.revokeObjectURL(url);
          return;
        }
        urlToRevoke = url;
        setPreviewUrl(url);
      })
      .catch((e) => {
        setPreviewError(typeof e === "string" ? e : e?.message || "No se pudo cargar la previsualización.");
      })
      .finally(() => setPreviewLoading(false));

    return () => {
      revoked = true;
      if (urlToRevoke) {
        window.URL.revokeObjectURL(urlToRevoke);
      }
      setPreviewUrl(null);
    };
  }, [openDoc]);

  return { previewUrl, previewLoading, previewError };
}
